import { getUserToken } from '../../pagesNext/live/Helpers';
import { processRequest } from '../../services/Api';
import { put, call, takeLatest, all, delay } from 'redux-saga/effects';
import { playButtonActionTypes } from './Constants';
import * as playButtonActions from './Actions';
import * as notificationActions from '../notification/Actions';
import * as onboardingModalActions from '../modals/onboarding/Actions';
import * as sharedActions from '../../pagesNext/shared/Actions';
import { SOURCE_TYPES, UPGRADE_MODALS_IDENTIFIER } from '../../services/Constants';
import { EVENTS_TYPES } from '../../pagesNext/shared/Constants';

export default function* () {
	yield all([yield takeLatest(playButtonActionTypes.GET_SONG_REQUEST, handleGetSong)]);
}

export function* handleGetSong(action) {
	try {
		const { id, word, lang, code } = action.payload || {};
		let userToken = null;

		if (code) {
			userToken = getUserToken(code);
		}

		let { data } = yield call(
			processRequest,
			`external_services/speak?lang=${lang}&word=${word}`,
			'GET',
			{},
			false,
			false,
			userToken ? { 'X-Live-Battle-Room-Token': userToken } : {},
		);
		let hasUrl = data.url;
		let counter = 0;

		while (!hasUrl && counter < 10) {
			const { data: data_ } = yield call(
				processRequest,
				`external_services/speak?lang=${lang}&word=${word}`,
				'GET',
				{},
				false,
				false,
				userToken ? { 'X-Live-Battle-Room-Token': userToken } : {},
			);
			counter += 1;

			yield delay(1000);
			hasUrl = data_.url;
			data = data_;
		}

		if (hasUrl) return yield put(playButtonActions.getSongSuccess(id, data));
		yield put(playButtonActions.removeSong());
	} catch (e) {
		if (e.response.data.error.toLowerCase().indexOf('plus of premium') !== -1) {
			yield put(
				onboardingModalActions.getOnboardingModalRequest({
					identifier: UPGRADE_MODALS_IDENTIFIER.RESTRICTED_DICTATION,
				}),
			);
			yield put(playButtonActions.setIsAudioPlaying(false));
			return yield put(
				sharedActions.sendEventRequest({
					event_name: EVENTS_TYPES.UPGRADE_MESSAGE_SEEN,
					source: SOURCE_TYPES.EXERCISE_DETAIL,
					feature: UPGRADE_MODALS_IDENTIFIER.RESTRICTED_DICTATION,
				}),
			);
		}
		yield put(notificationActions.createNotification(e.response.data.error, null, true, 5000));
		yield put(playButtonActions.removeSong());
	}
}
